import React from 'react';
import DateTimeReportLine from './DateTimeReportLine';
import { ValidityPeriodText } from './Dialog';

const RECURRENCE_LABELS = {
  daily: 'Täglich',
  weekly: 'Wöchentlich',
  biweekly: 'Jeden 2. ',
  triweekly: 'Jeden 3. ',
  fourweekly: 'Jeden 4. ',
  monthly_first: 'Jeden 1. ',
  monthly_second: 'Jeden 2. ',
  monthly_third: 'Jeden 3.',
  monthly_fourth: 'Jeden 4. ',
  monthly_last: 'Jeden letzten',
};

const DAYS_DE_LONG = {
  monday: 'Montag', tuesday: 'Dienstag', wednesday: 'Mittwoch',
  thursday: 'Donnerstag', friday: 'Freitag', saturday: 'Samstag', sunday: 'Sonntag',
};

const RecurringEventsDisplay = ({ eventSchedule }) => {
  const rec = eventSchedule.recurrence || 'daily';
  const { valid_from, valid_until } = eventSchedule;

  const validityFromToText = <ValidityPeriodText validFrom={valid_from} validUntil={valid_until} />;

  if (rec === 'daily') {
    const times = [];
    if (eventSchedule.start_time) times.push({ start_time: eventSchedule.start_time, end_time: eventSchedule.end_time });
    (eventSchedule.additional_times || []).forEach(tp => times.push(tp));

    return (
      <div className="opening-hours-list">
        {times.map((tp, i) => (
          <DateTimeReportLine
            key={i}
            label="Täglich"
            dayData={{ opens: tp.start_time, closes: tp.end_time || '' }}
            onAdd={() => {}}
            onRemove={() => {}}
            onUpdate={() => {}}
          />
        ))}
        {validityFromToText}
      </div>
    );
  }

  // Wöchentliche und monatliche Wiederholung
  const recLabel = RECURRENCE_LABELS[rec] || rec;
  const dayLabel = eventSchedule.day_of_week ? DAYS_DE_LONG[eventSchedule.day_of_week] : null;
  const recDescription = (dayLabel ? `${recLabel} ${dayLabel}` : recLabel) + (rec.startsWith('monthly_') ? ' im Monat' : '');

  const times = [];
  if (eventSchedule.start_time) times.push({ start_time: eventSchedule.start_time, end_time: eventSchedule.end_time });
  (eventSchedule.additional_times || []).forEach(tp => times.push(tp));

  return (
    <div className="opening-hours-list">
      {times.map((tp, i) => (
        <DateTimeReportLine
          key={i}
          label={recDescription}
          dayData={{ opens: tp.start_time, closes: tp.end_time || '' }}
          onAdd={() => {}}
          onRemove={() => {}}
          onUpdate={() => {}}
        />
      ))}
      {validityFromToText}
    </div>
  );
};

export default RecurringEventsDisplay;
